import { FC } from "react";
import ToastSpinner from "./ToastSpinner";

const Icon: FC<{ type?: "success" | "error" | "loading" }> = ({
  type = "",
}) => {
  switch (type) {
    case "success":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
            fill="#ECF9F1"
          />
          <path
            d="M17.0777 9.23071L10.3084 15.6923L6.92383 12.4615"
            stroke="#42BE77"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "error":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.9988 23.0768C18.1164 23.0768 23.0757 18.1175 23.0757 11.9999C23.0757 5.88228 18.1164 0.922974 11.9988 0.922974C5.88118 0.922974 0.921875 5.88228 0.921875 11.9999C0.921875 18.1175 5.88118 23.0768 11.9988 23.0768Z"
            fill="#FFF4F2"
          />
          <path
            d="M15.6932 8.30762L8.30859 15.6922"
            stroke="#F64629"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.6932 15.6922L8.30859 8.30762"
            stroke="#F64629"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "loading":
      return <ToastSpinner />;
    default:
      return null;
  }
};

export default Icon;
